import {RENEWAL_TYPE} from "./config";

/**
 * 性别过滤器
 * @param str
 * @param type
 * @returns {string}
 */
export function sexFilter(str, type = 1) {
    if (!str) return '';
    let data = {};
    str = str.toLowerCase();
    if (type === 1) {
        data = {f: '女', m: '男', n: '未知', '1': '男', '2': '女', '男': '男', '女': '女'};
    }
    return data[str] || '';
}

/**
 *
 * @param str
 * @returns {*}
 */
export function renewalTypeFilter(str) {
    const type = RENEWAL_TYPE.find(r => r.id === str);
    if (type && type.name) return type.name;
    return "";
}

/**
 * 由身份证获得sex
 * @param str
 * @returns {string}
 */
export const getSexFromIdCardFilter = function (str) {
    if (!str) return '';
    if (str.length === 18) {
        const sex = str.substring(16, 17);
        return sex % 2 === 1 ? '男' : '女';
    } else {
        return ''
    }
}

/**
 * 由身份证获得age
 * @param str
 * @returns {*}
 */
export const getAgeFromIdCardFilter = function (str, next = '岁') {
    if (!str) return '';
    const y = new Date().getFullYear();
    if (str.length === 18) {
        return (y - str.substring(6, 10)) + next;
    } else {
        return "";
    }
}

/**
 * 由身份证获得出生年月日
 * @param str
 * @returns {*}
 */
export const getBirthdayFromIdCardFilter = function (str, line = false) {
    if (!str) return '';
    let year = str.slice(6, 10)
    let month = str.slice(10, 12)
    let day = str.slice(12, 14)
    if (line) {
        return year + '-' + month + '-' + day
    } else {
        return year + '年' + month + '月' + day + '日'
    }
}

/**
 * 隐藏部分字符串
 * @param str
 * @param start
 * @param end
 * @param length
 * @returns {string}
 */
export const hiddenStr = function (str, start, end, length) {
    if (!str) return '';
    return str.substring(0, start) + new Array(length).fill('*').join('') + str.substring(str.length - end);
}
/**
 * 排班日期过滤器
 * @param str
 * @returns {string}
 */
export const schdateFilter = (str) => {
    if (!str) return '';
    if (str.length === 10) return str;
    return str.substr(0, 4) + '-' + str.substr(4, 2) + '-' + str.substr(6);
};

/**
 * 上下午过滤器
 * @param str
 * @returns {string|*}
 */
export const ampmFilter = (str) => {
    if (!str) return '';
    return {'1': '上午', '2': '下午'}[str];
}

/**
 * 叁体视频类型[screen,video,sip]
 * @param str
 */
export const tee3VideoTypeFilter = (str) => {
    if (!str) return '';
    return {
        screen: '屏幕共享',
        video: '摄像头',
        sip: '高清设备',
        "local-video": '本机摄像头',
        "local-screen": '本机屏幕共享'
    }[str] || '暂无' + str;
};


// 小数点运算
//js 加法计算
//调用：accAdd(arg1,arg2)
//返回值：arg1加arg2的精确结果
export function accAdd(arg1, arg2) {
    let r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return ((arg1 * m + arg2 * m) / m).toFixed(2);
}

//js 减法计算
//调用：Subtr(arg1,arg2)
//返回值：arg1减arg2的精确结果
export function Subtr(arg1, arg2) {
    let r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    //last modify by deeka
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(2);
}

//js 乘法函数
//调用：accMul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
export function accMul(arg1, arg2) {
    let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
        m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//js 除法函数
//调用：accDiv(arg1,arg2)
//返回值：arg1除以arg2的精确结果
export function accDiv(arg1, arg2) {
    let t1 = 0, t2 = 0, r1, r2;
    try {
        t1 = arg1.toString().split(".")[1].length
    } catch (e) {
    }
    try {
        t2 = arg2.toString().split(".")[1].length
    } catch (e) {
    }
    r1 = Number(arg1.toString().replace(".", ""))
    r2 = Number(arg2.toString().replace(".", ""))
    return (r1 / r2) * Math.pow(10, t2 - t1);

}